import { FC } from 'react';

import { ChatMessageGenerationType, ChatMessageRoleType } from '../../../models';

import { MarkdownWithLinks, renderUserMessage } from '../../../components/MarkdownWithLinks'

import { determineDirection } from '../../../utils'

import ChatMessageImage from './ChatMessageImage'

interface Props {
  isSending: boolean
  messageRole: ChatMessageRoleType,
  generationType: ChatMessageGenerationType
  diacritizedMessage: string | undefined
  translatedMessage: string | undefined
  generatedAudioUrl: string | undefined
  audioAutoPlay: boolean
  audioRef: React.RefObject<HTMLAudioElement>
  hasImage?: boolean
  generatedImageUrl: string | undefined
  searchedImages: string[] | undefined
  onLoadGeneratedImage?: () => void
  imageReaction?: string | undefined
  handleReaction: (reaction: string, type: string) => void
  downloadFile: (url: string, type: string) => void
}


const ChatMessageOptionResult: FC<Props> = ({ isSending, messageRole, generationType, diacritizedMessage, translatedMessage, generatedAudioUrl, audioAutoPlay, audioRef, hasImage, generatedImageUrl, onLoadGeneratedImage, searchedImages, handleReaction, imageReaction, downloadFile}) => {

  const translatedMessageDirection = translatedMessage ? determineDirection(translatedMessage) : null

  return <>
    {diacritizedMessage && (
      <div className="text-gray-700 lh-lg mt-2 mb-n2">
        { messageRole === ChatMessageRoleType.USER ?
          renderUserMessage(diacritizedMessage)
        :
          <MarkdownWithLinks>{diacritizedMessage}</MarkdownWithLinks>
        }
      </div>
    )}
    {translatedMessage && (
      <div className="text-gray-700 lh-lg mt-2 mb-n2" style={translatedMessageDirection ? {direction:translatedMessageDirection} : {}}>
        { messageRole === ChatMessageRoleType.USER ?
          renderUserMessage(translatedMessage)
        :
          <MarkdownWithLinks>{translatedMessage}</MarkdownWithLinks>
        }
      </div>
    )}
    {generatedAudioUrl && (
      <audio
        controls
        controlsList={`${
          generationType != ChatMessageGenerationType.TEXT &&
          "nodownload"
        }`}
        autoPlay={audioAutoPlay}
        className={`w-100 ${![ChatMessageGenerationType.SPEECH, ChatMessageGenerationType.MUSIC].includes(generationType)  && 'my-2'}`}
        ref={audioRef}
      >
        <source src={generatedAudioUrl} type="audio/wav" />
      </audio>
    )}
    { hasImage && (
      <ChatMessageImage
        isNotImageGeneration={generationType !== ChatMessageGenerationType.IMAGE}
        isSending={isSending}
        generatedImageUrl={generatedImageUrl}
        onLoadGeneratedImage={onLoadGeneratedImage}
        handleReaction={handleReaction}
        imageReaction={imageReaction}
        downloadFile={downloadFile}
      />
    )}
    {searchedImages && (
      <div className="d-flex flex-wrap lh-lg mt-2">
        {searchedImages.map((url: any, index: number) => (
          <img key={index} src={url} className="w-100 mw-400px rounded mb-2" />
        ))}
      </div>
    )}
  </>
}

export { ChatMessageOptionResult }